// extracted by mini-css-extract-plugin
module.exports = {"colorField":"CwColorField-colorField","colorFieldTriggerField":"CwColorField-colorFieldTriggerField","swatchSelected":"CwColorField-swatchSelected"};